import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "puestos",
    "puestos",
    "PuestosForm",
    "/puestos",
);

export default handleActions(reducers, initialState);
